export const environment = {
  production: false,
  host: 'https://dev.music-backend.examplewww.com',
  restAuthHost: 'https://dev.music-backend.examplewww.com/rest-auth/',
  wsHost: 'wss://dev.music-backend.examplewww.com/websockets/',
  apiHost: 'https://dev.music-backend.examplewww.com/api-v1',
  youTubeApiKey: 'AIzaSyC03gPQkkgw0aSP5wIKgawZ9pE0ET34-3Q',
  invitationFlow: true,
};
